module.exports = __webpack_public_path__ + "static/media/feature_pict_1.c948ff06.svg";